// Taggable element constants for IB curriculum programmes (PYP / DP / MYP / UBD).
// Extracted from src/AppComponents/Post/modules/PostModule.js to break a
// circular dependency between PostModule and modules/ElementValueUtils, and
// because these constants are curriculum-element data, not Post-domain data.

import {
  ELEMENT_TYPE_PYP_ACTION,
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
  ELEMENT_TYPE_DP_SYLLABUS,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
} from "Constants/stringConstants";
import {
  ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
} from "Constants/permissionConstants";

export const TAGGABLE_PYP_ELEMENTS = [
  {
    label: "common:atls_label",
    value: "atls",
    isNestedView: true,
    startDepth: 1,
    dynamicPlannerElementLabelPerm: ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
    elementType: ELEMENT_TYPE_PYP_ATL,
  },
  {
    label: "common:lp_label",
    value: "lp",
    isNestedView: false,
    dynamicPlannerElementLabelPerm: ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
    elementType: ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  },
  {
    label: "common:concept_plural",
    value: "concepts",
    isNestedView: false,
  },
  {
    label: "common:content_standards",
    value: "benchmarks",
    isNestedView: true,
    startDepth: 0,
    dynamicPlannerElementLabelPerm: ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
    elementType: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  },
  {
    label: "common:action_label",
    value: "action",
    isNestedView: false,
    dynamicPlannerElementLabelPerm: ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
    elementType: ELEMENT_TYPE_PYP_ACTION,
  },
];

export const TAGGABLE_PYP_ELEMENTS_V2 = [
  ...TAGGABLE_PYP_ELEMENTS,
  {
    label: "common:lois_label",
    value: "lois",
    dynamicPlannerElementLabelPerm: ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
    elementType: "LOI",
  },
];

export const TAGGABLE_DP_ELEMENTS = [
  {
    label: "common:aim_label",
    value: "aimDP",
    isNestedView: true,
    startDepth: 1,
  },
  {
    label: "common:objectives_label",
    value: "objectivesDP",
    isNestedView: true,
    startDepth: 1,
  },
];

export const TAGGABLE_DP_ELEMENTS_V2 = [
  {
    label: "planningInsights:lpa",
    value: "learnerProfileDP",
    isNestedView: false,
    isGlobal: true,
    elementType: ELEMENT_TYPE_DP_LEARNER_PROFILE,
  },
  {
    label: "common:atls_label",
    value: "atlDP",
    isNestedView: true,
    startDepth: 1,
    isGlobal: true,
    elementType: ELEMENT_TYPE_DP_ATL,
  },
  {
    label: "common:content_standards",
    value: "subjectStandardDP",
    isNestedView: true,
    startDepth: 1,
    isGlobal: true,
    elementType: ELEMENT_TYPE_DP_LEARNING_STANDARD,
  },
  {
    label: "common:syllabus_content_label",
    value: "syllabusContentDP",
    isNestedView: true,
    startDepth: 1,
    elementType: ELEMENT_TYPE_DP_SYLLABUS,
  },
];

export const TAGGABLE_MYP_ELEMENTS = [
  {
    label: "common:myp_objectives",
    value: "objectivesMYP",
    isNestedView: true,
    startDepth: 1,
    elementType: "MYP_OBJECTIVES",
    isGlobal: false,
    dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  },
  {
    label: "common:atls_label",
    value: "atlsMYP",
    isNestedView: true,
    startDepth: 1,
    elementType: "MYP_ATL",
    //isGlobal: true,
    isGradeSpecific: true,
    dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  },
  {
    label: "common:concept_plural",
    value: "conceptsMYP",
    isNestedView: false,
    elementType: "MYP_KEY_CONCEPT",
    isGlobal: true,
    dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  },
  {
    label: "common:related_concepts",
    value: "relatedConceptsMYP",
    isNestedView: false,
    elementType: "MYP_RELATED_CONCEPT",
    isGlobal: false,
    dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  },
  {
    label: "common:specified_concepts",
    value: "specifiedConcepts",
    isNestedView: false,
    elementType: "MYP_SPECIFIED_CONCEPTS",
    isGlobal: true,
    dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  },
  {
    label: "common:lp_label",
    value: "lpMYP",
    isNestedView: false,
    elementType: "MYP_LEARNER_PROFILE",
    isGlobal: true,
    dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  },
  {
    label: "common:content_standards",
    value: "learningStandardMYP",
    isNestedView: true,
    startDepth: 0,
    elementType: "MYP_LEARNING_STANDARD",
    isGlobal: false,
    isGradeSpecific: true,
    isSubjectSpecific: true,
    dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  },
  {
    label: "common:myp_interdisciplinary_objectives",
    value: "interdisciplinaryCriteriaMYP",
    elementType: "MYP_OBJECTIVES",
    startDepth: 2,
    isGlobal: false,
    isNestedView: true,
    dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  },
];

export const TAGGABLE_MYP_ELEMENTS_V2 = [
  ...TAGGABLE_MYP_ELEMENTS,
  {
    label: "common:inquiry_questions",
    value: "inquiryQuestions",
    elementType: "INQUIRY_QUESTIONS",
    dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  },
];

export const TAGGABLE_UBD_ELEMENTS = [
  {
    label: "common:skill_plural",
    isDynamicPlannerElementLabel: true,
    value: "atlsUBD",
    isNestedView: true,
    startDepth: 1,
    elementType: "UBD_ATL",
    isGradeSpecific: true,
  },
  {
    label: "common:content_standards",
    isDynamicPlannerElementLabel: true,
    value: "learningStandardUBD",
    isNestedView: true,
    startDepth: 0,
    elementType: "UBD_LEARNING_STANDARD",
    isGradeSpecific: true,
    isSubjectSpecific: true,
  },
];

export const TAGGABLE_ELEMENTS_FIELD_LIST = {
  IB_MYP: {
    atlsMYP: {
      config: {
        plannerElementConfig: {
          type: "MYP_ATL",
        },
        fieldTypeConfig: {
          rootNodeDepth: 1,
        },
        type: "PLANNER_ELEMENT",
      },
      viewType: "Nestedview",
    },
    objectivesMYP: {
      config: {
        plannerElementConfig: {
          type: "MYP_OBJECTIVES",
          subType: "PERSONAL_OBJECTIVES",
        },
        fieldTypeConfig: {
          rootNodeDepth: 2,
        },
        type: "PLANNER_ELEMENT",
      },
      viewType: "Nestedview",
    },
    interdisciplinaryCriteriaMYP: {
      config: {
        plannerElementConfig: {
          type: "MYP_OBJECTIVES",
          subType: "INTERDISCIPLINARY_CRITERIA",
        },
        fieldTypeConfig: {
          rootNodeDepth: 2,
        },
        type: "PLANNER_ELEMENT",
      },
      viewType: "Nestedview",
    },
    disciplinaryObjectivesMYP: {
      config: {
        plannerElementConfig: {
          type: "MYP_OBJECTIVES",
          subType: "PERSONAL_OBJECTIVES",
        },
        fieldTypeConfig: {
          rootNodeDepth: 2,
        },
        type: "PLANNER_ELEMENT",
      },
      viewType: "Nestedview",
    },
    conceptsMYP: {
      config: {
        type: "PLANNER_ELEMENT",
        fieldTypeConfig: {
          multi: true,
        },
        plannerElementConfig: {
          type: "MYP_KEY_CONCEPT",
          filteredBy: ["subjectGroup"],
          shouldPrefetch: true,
        },
      },
    },
    learningStandardMYP: {
      type: "NestedSelectComponent",
      config: {
        icon: "PicnLearningStandards",
        type: "PLANNER_ELEMENT",

        fieldTypeConfig: {
          rootNodeDepth: 0,
        },

        plannerElementConfig: {
          type: "MYP_LEARNING_STANDARD",
        },
      },
      viewType: "Nestedview",
    },
    disciplinaryLearningStandardMYP: {
      type: "NestedSelectComponent",
      config: {
        icon: "PicnLearningStandards",
        type: "PLANNER_ELEMENT",

        fieldTypeConfig: {
          rootNodeDepth: 0,
        },

        plannerElementConfig: {
          type: "MYP_LEARNING_STANDARD",
        },
      },
      viewType: "Nestedview",
    },
    lpMYP: {
      type: "MultiSelect",
      config: {
        type: "PLANNER_ELEMENT",

        fieldTypeConfig: {
          multi: true,
        },
        hasAddRemoveValues: true,
        plannerElementConfig: {
          type: "MYP_LEARNER_PROFILE",
        },
      },
    },
    relatedConceptsMYP: {
      type: "NestedSelectComponent",
      config: {
        type: "PLANNER_ELEMENT",
        fieldTypeConfig: {
          rootNodeDepth: 0,
        },
        multiSelectConfig: {
          multi: true,
        },
      },
      hasAddRemoveValues: true,
      plannerElementConfig: {
        type: "MYP_RELATED_CONCEPT",
      },
    },
    specifiedConcepts: {
      type: "NestedSelectComponent",
      config: {
        type: "PLANNER_ELEMENT",
        fieldTypeConfig: {
          rootNodeDepth: 0,
        },
        multiSelectConfig: {
          multi: true,
        },
      },
      hasAddRemoveValues: true,
      plannerElementConfig: {
        type: "MYP_SPECIFIED_CONCEPTS",
      },
    },
  },
  UBD: {
    atlsUBD: {
      config: {
        plannerElementConfig: {
          type: "UBD_ATL",
        },
        type: "PLANNER_ELEMENT",
      },
      viewType: "Nestedview",
    },
    learningStandardUBD: {
      config: {
        plannerElementConfig: {
          type: "UBD_LEARNING_STANDARD",
        },
        fieldTypeConfig: {
          rootNodeDepth: 0,
        },
        type: "PLANNER_ELEMENT",
      },
      viewType: "Nestedview",
    },
  },
};
